import React from "react";

const backInTimeInfo = [
  {
    categoryName: 'D1 Schools',
    gameScores: '2005-06',
    playerAndTeamStats: '2009-10',
    notes: <>Exceptions that go further back than 2009-10:
      <ul style={{ paddingLeft: '20px' }}>
        <li>D1 team W-L records complete back to 1981-82, or the team&apos;s first season</li>
        <li>Big East game scores complete back to 1982-83 (first season of the conference)</li>
        <li>Current Big East schools game scores complete back to 1981-82 (or 1st D1 season) except Butler which goes back to 1995-96</li>
        <li>Big 12 game scores complete back to 1996-97</li>
        <li>Big Ten game scores complete back to 1996-97</li>
        <li>ACC game scores complete back to 2003-04</li>
        <li>SEC game scores complete back to 2003-04</li>
      </ul>
    </>,
  },
  {
    categoryName: 'Poll Ranked Teams',
    gameScores: '1981-82',
    playerAndTeamStats: '2009-10',
    notes: '',
  },
  {
    categoryName: 'NCAA Tournament',
    gameScores: '1981-82',
    playerAndTeamStats: '2009-10',
    notes: '',
  },
  {
    categoryName: 'WNIT Tournament',
    gameScores: '1997-98',
    playerAndTeamStats: '2009-10',
    notes: '',
  },
  {
    categoryName: 'A 10 Tournament',
    gameScores: '1982-83 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'A-Sun Tournament',
    gameScores: '1985-86 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'AAC Tournament',
    gameScores: '2013-14 *',
    playerAndTeamStats: '2013-14 *',
    notes: '',
  },  
  {
    categoryName: 'ACC Tournament',
    gameScores: '1977-78 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'America East Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Big 12 Tournament',
    gameScores: '1996-97 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Big East Tournament',
    gameScores: '1982-83 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Big Sky Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Big South Tournament',
    gameScores: '1986-87 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Big Ten Tournament',
    gameScores: '1994-95 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Big West Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'C-USA Tournament',
    gameScores: '1995-96 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'CAA Tournament',
    gameScores: '1994-95',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Great West Tournament',
    gameScores: '2009-10 *',
    playerAndTeamStats: '2009-10 *',
    notes: '',
  },  
  {
    categoryName: 'Horizon Tournament',
    gameScores: '1988-89',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Ivy Tournament',
    gameScores: '2016-17 *',
    playerAndTeamStats: '2016-17 *',
    notes: '',
  },  
  {
    categoryName: 'MAAC Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'MAC Tournament',
    gameScores: '1981-82',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'MEAC Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'MVC Tournament',
    gameScores: '1991-92',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'MWC Tournament',
    gameScores: '1999-00 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'NEC Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'OVC Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Pac 12 Tournament',
    gameScores: '2001-02 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Patriot Tournament',
    gameScores: '1990-91 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'SEC Tournament',
    gameScores: '1979-80 *',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Southern Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Southland Tournament',
    gameScores: '1990-91',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Summit Tournament',
    gameScores: '1992-93',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'Sun Belt Tournament',
    gameScores: '1990-91',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'SWAC Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'WAC Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },  
  {
    categoryName: 'WCC Tournament',
    gameScores: '1996-97',
    playerAndTeamStats: '2009-10',
    notes: '',
  },
];

export default backInTimeInfo;







																
										
